import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDialog"]
  static values = { openStartOnConnect: { type: Boolean, default: false } }

  connect() {
    if (this.openStartOnConnectValue) {
      this.openStart()
    }
  }

  openStart() {
    if (this.hasStartDialogTarget) {
      this.startDialogTarget.showModal()
    }
  }
}
